<template>
    <div class="col-12">
        <label for="input-select" class="form-label">
            <i v-if="icon" :class="['mdi', icon, 'font-18', 'me-1']"></i>
            {{ label }}
        </label>
    </div>
        <div class="col-12">
            <div class="row g-1">
            <div :class="{'col-12': input.input_number == 0, 'col-md-10': input.input_number != 0}">
                <select class="form-select" id="input-select" v-model.number="input.input_number">
                    <option value="0">{{ $t('common.disabled') }}</option>
                    <option v-for="input in inputs" :key="input.intput_number" :value="input.input_number">
                        {{ input.toString() }}
                    </option>
                </select>
            </div>
            <div v-if="input.input_number > 0" class="col-12 col-md-2">
                <select class="form-select" id="type-input-select" v-model="input.input_type">
                    <option value="NO">NO</option>
                    <option value="NC">{{ $t('externalInput.normallyClosed') }}</option>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
import Input from '@/models/input';

export default {
    name: 'ExternalInput',
    props: {
        label: {
            type: String,
            required: true
        },
        icon: {
            type: String,
            required: true
        },
        inputValue: {
            type: Input,
            required: true
        },
        inputs: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            input: this.inputValue
        };
    },   
};
</script>
